import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportTemplateModel} from '../reportTemplate.model';
import {Injectable} from '@angular/core';

@Injectable()
export class ReportTemplateConverter extends HttpModelConverter<ReportTemplateModel>{
    protected createInstance(): ReportTemplateModel {
        return new ReportTemplateModel();
    }

    protected enrichObject(result: ReportTemplateModel, src: ReportTemplateModel) {
    }

}
